import Vue from 'vue'
import App from './App.vue'
import common from '@/utils/common.js'

//是否产生生产提示
Vue.config.productionTip = false

//解决两次点击相同路由时的报错
import Router from 'vue-router'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

//添加修改时间格式的插件
import moment from 'moment'//导入moment插件
import momentTimezone from 'moment-timezone'

const momentTime = momentTimezone.tz.guess()
moment.tz.setDefault('momentTime');

Vue.prototype.$moment = moment;//添加到vue的原型上
Vue.prototype.common = common;//添加到vue的原型上
moment.locale('zh-cn');//如果需要汉化可自行添加

//导入抽取的路由
import router from './router'

//导入初始化样式
import './style/base.css'

//导入仓库
import store from "./store/store"

//导入element-ui
import ElementUI from 'element-ui';
//导入element-ui的样式
import 'element-ui/lib/theme-chalk/index.css';
//将element-ui改成国际版
import locale from '../node_modules/element-ui/lib/locale/lang/en'

//引入iconfont图标的css文件
import './style/iconfont/iconfont.css'

//引入iconfont图标的css文件


//导入jquery并且导入插件相关文件
// import $ from 'jquery'

//引入swiper插件，并且引入插件相关的css文件
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import '../node_modules/swiper/dist/css/swiper.css'
// import'../node_modules/swiper/dist/js/swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//使用elementUI
Vue.use(ElementUI,{locale}); 


new Vue({
  router,
  //挂载到vue实例---路由
  render: h => h(App),
  
  //挂载到vue---仓库
  store
}).$mount('#app')
